exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_settings_2tF5uAIjscy44G0iPWlaM1 {\n  width: 100%;\n  float: left;\n  clear: both;\n  box-sizing: border-box;\n}\n\n.IA_settings_2tF5uAIjscy44G0iPWlaM1 h3 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.IA_settings_error_message_2sWw-BxzcNDnGKXFx5hklj {\n  color: red;\n  margin-top: 10px;\n}\n\n.IA_notification_toggle_text_37YX7UkkxQ_-LPmK4LjhKn {\n  font-size: 12px;\n  color: gray;\n  display: inline-block;\n}", ""]);

// Exports
exports.locals = {
	"IA_settings": "IA_settings_2tF5uAIjscy44G0iPWlaM1",
	"IA_settings_error_message": "IA_settings_error_message_2sWw-BxzcNDnGKXFx5hklj",
	"IA_notification_toggle_text": "IA_notification_toggle_text_37YX7UkkxQ_-LPmK4LjhKn"
};